/**
 * Default Theme Configuration
 * Uses Shapermint theme from afrodita-components
 */

import { shapermintTheme } from '@template-project/afrodita-components';

/**
 * Export Shapermint theme as default
 * Can be overridden per environment or store
 */
export const defaultTheme = shapermintTheme;

/**
 * Legacy color palette (kept for reference)
 */
const legacyColors = {
  primary: {
    color: '#000000',
    contrast: '#FFFFFF',
  },
  secondary: {
    color: '#FFFFFF',
    contrast: '#000000',
  },
  background: {
    default: '#FFFFFF',
    paper: '#F5F5F5',
  },
  text: {
    primary: '#000000',
    secondary: '#666666',
    disabled: '#999999',
  },
  border: {
    default: '#E0E0E0',
    light: '#F0F0F0',
  },
  success: {
    color: '#4CAF50',
    contrast: '#FFFFFF',
  },
  error: {
    color: '#F44336',
    contrast: '#FFFFFF',
  },
  warning: {
    color: '#FF9800',
    contrast: '#000000',
  },
  info: {
    color: '#2196F3',
    contrast: '#FFFFFF',
  },
};

/**
 * Typography configuration
 */
const typography = {
  h1: {
    fontSize: '2.5rem',
    lineHeight: 1.2,
    fontWeight: 700,
  },
  h2: {
    fontSize: '2rem',
    lineHeight: 1.3,
    fontWeight: 700,
  },
  h3: {
    fontSize: '1.75rem',
    lineHeight: 1.4,
    fontWeight: 600,
  },
  h4: {
    fontSize: '1.5rem',
    lineHeight: 1.4,
    fontWeight: 600,
  },
  h5: {
    fontSize: '1.25rem',
    lineHeight: 1.5,
    fontWeight: 600,
  },
  h6: {
    fontSize: '1rem',
    lineHeight: 1.5,
    fontWeight: 600,
  },
  body1: {
    fontSize: '1rem',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  caption: {
    fontSize: '0.75rem',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  button: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    fontWeight: 500,
    textTransform: 'uppercase' as const,
  },
};

/**
 * Spacing scale (8px base)
 */
const spacing = {
  xs: '0.25rem', // 4px
  sm: '0.5rem', // 8px
  md: '1rem', // 16px
  lg: '1.5rem', // 24px
  xl: '2rem', // 32px
  '2xl': '3rem', // 48px
  '3xl': '4rem', // 64px
};

/**
 * Border radius tokens
 */
const radius = {
  none: '0',
  sm: '0.25rem', // 4px
  md: '0.5rem', // 8px
  lg: '1rem', // 16px
  full: '9999px',
};

/**
 * Shadow/elevation tokens
 */
const shadow = {
  xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
};

// Theme is now imported from afrodita-components at the top

